import { AppRemixIcon } from '@/layout/AppComponents';
import styled from "styled-components";

export default function AppSubmitButton(props) {
  const {
    children,
    className = '',
    icon,
    isSubmitting = false,
    ...others
  } = props;

  return (
    <Button
      type="submit"
      className={`${className} ${isSubmitting ? "disabled" : ""}`}
      disabled={isSubmitting}
      {...others}
    >
      <span className="d-inline-flex align-items-center">
        {icon && <AppRemixIcon icon={icon} className="mr-1" />}
        {children}
        <AppRemixIcon
          icon="loader-4"
          className={`icn-spinner ml-2 ${
            isSubmitting ? "" : "icn-spinner-hide"
          }`}
        />
      </span>
    </Button>
  );
}

const Button = styled.button`
  .icn-spinner {
    animation: spin-animation 2s infinite;
    animation-timing-function: linear;
    display: inline-block;
  }
  .icn-spinner-hide {
    opacity: 0;
  }
  @keyframes spin-animation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(359deg);
    }
  }
`;
